export const education = [
    {
        "date": "2017 - 2021",
        "name": "Duzce University",
        "agno": "3.32"
    },
    {
        "date": "2013 - 2017",
        "name": "Bodrum Anadolu High School",
        "agno": "78,40"
    }

]